export const formatCurrency = (
  amount: number,
  currencyCode: string = "USD"
): string => {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currencyCode,
    maximumFractionDigits: 2,
  });

  return formatter.format(amount);
};
